// Shared helpers for document-level keyboard handlers.

// True when the event target is an editable text surface, where a global
// shortcut handler must NOT steal the keystroke. Every document-level keydown
// handler should guard with this before acting.
export function isTypingTarget(target) {
  if (!target) return false;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || target.isContentEditable === true;
}
